import React from "react";
import { T } from "../../../app/tokens.js";
import { areaLifecycleLabel } from "../leaseAreaPresentation.js";

export function AreaLifecycleBadge({ area }) {
  if (area.status === "active") return <span data-testid="active-area-dot" aria-label="Active"
    style={{ display: "inline-block", width: 6, height: 6, borderRadius: "50%", background: T.green, marginRight: 6 }} />;
  const label = areaLifecycleLabel(area);
  if (!label) return null;
  const inBuild = area.status === "in_build";
  return <span data-testid={inBuild ? "in-build-pill" : `${area.status}-area-pill`}
    style={{ display: "inline-flex", alignItems: "center", fontSize: T.fsXxs,
      fontWeight: T.fwSemibold, padding: "2px 7px", borderRadius: inBuild ? 4 : 999,
      background: inBuild ? T.buildBlueBg : T.lightGray, color: inBuild ? T.buildBlue : T.mid,
      border: `1px solid ${inBuild ? `${T.buildBlue}22` : T.border}`, marginLeft: 6, whiteSpace: "nowrap",
      ...(inBuild ? { textTransform: "uppercase", letterSpacing: "0.06em", lineHeight: 1.3 } : {}) }}>{label}</span>;
}
